import { render, staticRenderFns } from "./TasksDay.vue?vue&type=template&id=10b9469a&scoped=true&"
import script from "./TasksDay.vue?vue&type=script&lang=js&"
export * from "./TasksDay.vue?vue&type=script&lang=js&"
import style1 from "./TasksDay.vue?vue&type=style&index=1&id=10b9469a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9469a",
  null
  
)

export default component.exports